"use strict";
var Observable_1 = require('../../Observable');
var skip_1 = require('../../operator/skip');
Observable_1.Observable.prototype.skip = skip_1.skip;
//# sourceMappingURL=skip.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/add/operator/skip.js
// module id = 539
// module chunks = 3